import { configureStore } from '@reduxjs/toolkit';
import themeSlice from "./slices/theme";
import mainSlice from './slices/main';

export const store = configureStore({
    reducer: {
        main: mainSlice,
        theme: themeSlice
    },
})